<template>
  <Card>
    <div class="funnel-header">
      本月产品转换漏斗
    </div>
    <div
      ref="funnel"
      style="height: 530px"
    />
  </Card>
</template>

<script>
import echart from 'echarts';
import { assign } from 'lodash';
import tinyColor from 'tinycolor2';

import Card from '../Card/Index';

import { mapping, legend, series } from './config';

export default {
  components: {
    Card,
  },

  props: {
    dataSource: {
      type: Object,
      required: true,
    },
  },

  computed: {
    legend() {
      return Object.keys(mapping).map((key) => {
        return mapping[key];
      });
    },

    series() {
      const data = this.dataSource;
      return Object.keys(data).map((key) => {
        return {
          value: data[key],
          name: mapping[key],
        };
      });
    },

    max() {
      const list = this.series.map((item) => item.value);
      return Math.max.apply(null, list);
    },

    color() {
      return this.legend.map((item, index) => {
        return tinyColor('#1C7AD9')
          .lighten(5 * index)
          .toString();
      });
    },
  },

  watch: {
    dataSource() {
      this.render();
    },
  },

  mounted() {
    this.chart = echart.init(this.$refs.funnel);
    this.render();
  },

  methods: {
    render() {
      const option = {
        color: this.color,
        legend: assign({}, legend, { data: this.legend }),
        series: [
          assign({}, series, { max: this.max, data: this.series }),
          assign({}, series, {
            max: this.max,
            label: {
              position: 'inside',
              formatter: '{d}',
            },
            data: this.series,
          }),
        ],
      };

      this.chart.setOption(option, true);
    },
  },
};
</script>

<style lang="less" scoped>
.funnel {
  &-header {
    font-weight: 600;
    color: rgba(48, 49, 51, 1);
    line-height: 18px;
    font-size: 18px;
  }
}
</style>